import React, { useContext } from 'react';

import UiContext from 'common/UiContext/UiContext';

import './info-text.scss';
import Icons from 'assets/images/Icons';

export type InfoTextProps = {
  content: Array<string>,
  copyable?: boolean,
  title?: string,
};

const InfoText = ({ content, copyable = false, title }: InfoTextProps) => {

  const { addToast } = useContext(UiContext);

  const copyText = ():void => {
    if(copyable) {
      navigator.clipboard.writeText(content.join('\n')).then(
        () => {
            addToast!('test copied');
        },
      );
    }
  };

  return (
    <>
      {title && (
        <h5>{title}</h5>
      )}
      <div className='infotext' onClick={copyText} role='contentinfo' >
        {content.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
        {copyable && (
          <div className='copyable'>
            <Icons name='Copy' />
          </div>
        )}
      </div>
    </>
  );
};

export default InfoText;